import * as React from 'react'
import { SVGProps } from 'react'
const SvgLetter = (props: SVGProps<SVGSVGElement>) => (
  <svg width={17} height={16} viewBox="0 0 17 16" fill="none" {...props}>
    <path
      d="M1.7 15.5c-.468 0-.868-.184-1.2-.55a1.903 1.903 0 0 1-.5-1.325V2.375c0-.516.166-.957.5-1.324C.831.684 1.231.5 1.7.5h13.6c.467 0 .868.184 1.2.55.334.368.5.81.5 1.325v11.25c0 .516-.166.957-.5 1.324-.332.367-.732.551-1.2.551H1.7Zm6.8-6.563L1.7 4.25v9.375h13.6V4.25L8.5 8.938Zm0-1.874 6.8-4.688H1.7l6.8 4.688ZM1.7 4.25V2.375v11.25V4.25Z"
      fill="#1C1915"
    />
  </svg>
)
export default SvgLetter
